if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.linked_collections = this.querySelector('linked-collections');
        console.log(this.linked_collections);
        this.linked_collection_objects = this.linked_collections.querySelectorAll('.linked-collection');
  
        if(this.linked_collection_objects.length){
          this.initLinkedCollections(this.linked_collection_objects);
        }
      }

    initLinkedCollections(linked_collections){
      linked_collections.forEach((collection) => {
        var products = collection.querySelectorAll('.product');

        products.forEach((product) => {
          console.log(product);
          product.addEventListener('click', this.addOnClick.bind(this, products));
        });
      });
    }

    addOnClick(products, evt){

      var square = evt.target.closest('.product');

      if (+square.dataset.button > 1) {
        console.log(+square.dataset.button);
          document.querySelector(`.addon.addon-${+square.dataset.button - 1}`).classList.remove('active');
          document.querySelector(`.addon.addon-${+square.dataset.button - 1}`).classList.add('close');
        }
      
      if(square.classList.contains('active')){
        const noButton = document.querySelector(`.notselected.notselected-${square.dataset.button}`);
        square.classList.remove('active');
        document.querySelector(`.notselected.notselected-${square.dataset.button}`).classList.add('active');
        if (square.dataset.button < 4) {document.querySelector(`.addon.addon-${+square.dataset.button + 1}`).classList.remove('active');}
        document.querySelector(`.addons-selected-${square.dataset.button}`).innerHTML = `${noButton.dataset.message}`;

      } else {
        square.classList.add('active');
        document.querySelector(`.notselected.notselected-${square.dataset.button}`).classList.remove('active');
        if (square.dataset.button < 4) {document.querySelector(`.addon.addon-${+square.dataset.button + 1}`).classList.add('active');}
        document.querySelector(`.addons-selected-${square.dataset.button}`).innerHTML = `${square.dataset.message}`;
      }

    }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // delete config.headers['Content-Type'];
        delete config.headers['Accepts'];

        // const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        // config.body = formData;



      var id = this.form.querySelector('input[name="id"]').value;
      var qty =  document.querySelector('input[name="quantity"]').value;

      var formData = {
        'sections': this.cart.getSectionsToRender().map((section) => section.id).join(),
        'sections_url': window.location.pathname,
        'items': [{
          'id': parseInt(id),
          'quantity': parseInt(qty)
        }]
      };
      
      if(this.linked_collection_objects.length){
        this.linked_collection_objects.forEach((collecton) => {
          var active_items = collecton.querySelectorAll('.product.active');

          if(active_items.length){
            active_items.forEach((item) => {
              formData.items.push({
                id: parseInt(item.dataset.productId),
                quantity: 1
              });
            });
          }
        });
      }

      if (this.dataset.cartType != 'page') {
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(formData);

        

        // fetch(`${routes.cart_add_url}`, config)
        //   .then((response) => response.json())
        //   .then((response) => {
        //     if (response.status) {
        //       publish(PUB_SUB_EVENTS.cartError, {
        //         source: 'product-form',
        //         productVariantId: formData.get('id'),
        //         errors: response.errors || response.description,
        //         message: response.message,
        //       });
        //       this.handleErrorMessage(response.description);

        //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        //       if (!soldOutMessage) return;
        //       this.submitButton.setAttribute('aria-disabled', true);
        //       this.submitButton.querySelector('span').classList.add('hidden');
        //       soldOutMessage.classList.remove('hidden');
        //       this.error = true;
        //       return;
        //     } else if (!this.cart) {
        //       window.location = window.routes.cart_url;
        //       return;
        //     }

        //     if (!this.error)
        //       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
        //     this.error = false;
        //     const quickAddModal = this.closest('quick-add-modal');
        //     if (quickAddModal) {
        //       document.body.addEventListener(
        //         'modalClosed',
        //         () => {
        //           setTimeout(() => {
        //             this.cart.renderContents(response);
        //           });
        //         },
        //         { once: true }
        //       );
        //       quickAddModal.hide(true);
        //     } else {
        //       this.cart.renderContents(response);
        //     }
        //   })
        //   .catch((e) => {
        //     console.error(e);
        //   })
        //   .finally(() => {
        //     this.submitButton.classList.remove('loading');
        //     if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //     if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //     this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        //   });

        fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          console.log("response", response);

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
       }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


